require('./informationCard.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
//@components
const TitleBox = require('components/commons/titleBox/titleBox');
const ProductInformation = require('components/commons/productInformation/productInformation');
const Card = require('components/commons/card/card');
//@utilities
import { FormattedText, formatText } from 'core/i18n';

const InformationCard = ({
    name,
    iban,
    product,
    jointHolderType,
    mainHolderName,
    showDebitInfo,
    showOpenCredit,
    children,
}) => {
    const type = formatText('jointHolderAccountType-jointHolder1');
    const userName = formatText('clientJointHolder-clientTitle', [name]);
    let welcome = formatText('clientJointHolder-clientWelcome', [mainHolderName]);
    let jointHolderText = null;
    let jointHolderAccountTypeInfo = null;

    if (showDebitInfo) {
        jointHolderAccountTypeInfo = (
            <p className="information-card__account-type-info">
                <FormattedText value="clientJointHolder-accountTypeInfo" />
            </p>
        );
        product = `${product}*`;
        if (showOpenCredit) {
            jointHolderAccountTypeInfo = (
                <p className="information-card__account-type-info-2">
                    *<FormattedText value="clientJointHolder-accountTypeInfo" />
                </p>
            );
            product = `${product}*`;
        }
    }

    if (jointHolderType === type && showOpenCredit) {
        welcome += '*';
        jointHolderText = (
            <div className="information-card--aclaration">
                <FormattedText value="clientJointHolder-openCreditText" />
            </div>
        );
    }

    return (
        <div className="information-card">
            <TitleBox
                title={userName}
                subTitle={welcome}
                titleModifier="--book"
                subTitleModifier="--bold"
                paragraphModifier="--light"
                container="--joint-holder"
                dash="dash"
            />
            <ProductInformation jointHolderType={jointHolderType} jointHolderAccountType={product} noPadding={false} />
            <Card icon="iban">
                <FormattedText value="cardIban-cardIban" injectedStrings={[iban]} />
            </Card>
            {jointHolderText}
            {jointHolderAccountTypeInfo}
            {children}
        </div>
    );
};

InformationCard.propTypes = {
    iban: PropTypes.string,
    name: PropTypes.string,
    product: PropTypes.string,
    jointHolderType: PropTypes.string,
    mainHolderName: PropTypes.string,
    showDebitInfo: PropTypes.bool,
    showOpenCredit: PropTypes.bool,
    children: PropTypes.any,
};

InformationCard.defaultProps = {
    iban: 'ESXX - XXXX - XXXX - XXXX - XXXX - XXXX',
};

module.exports.constructor = InformationCard;
module.exports = InformationCard;
